<template>
  <div class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">
          <TraderOperators></TraderOperators>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import APIClient from "@/service/APIClient";
import {useNotification} from "@kyvg/vue3-notification";
import TraderOperators from "@/components/users/TraderOperators.vue";

const api = new APIClient();
const notification = useNotification()

export default defineComponent({
  components: {
    TraderOperators,
  },
  setup() {


    return {
    }
  }
})
</script>
